import React from 'react';
import PropTypes from 'prop-types';
import RadioComponent from 'shared/components/RadioComponent';
import Label from 'shared/components/Label';

const PrototypeStencilType = (props) => {
  const {
    label,
    name,
    required,
    tooltip,
    groupName,
    onChangeParameter,
    variants,
    parameters,
    errorMessage,
  } = props;

  const onChange = (e) => onChangeParameter(name, e.target.value);
  const options = {};

  if (variants && variants.length > 0) {
    variants.forEach((v) => {
      v.option_values.forEach((optionValue) => {
        const aditionalPrice = parseFloat(optionValue.aditional_price) || 0.0;
        if (optionValue.option_type_name === name) {
          options[optionValue.name] = `${optionValue.presentation}${aditionalPrice > 0 ? ` (+$${aditionalPrice})` : ''}`;
        }
      });
    });
  }

  const items = Object.keys(options).map((value) => {
    const presentation = options[value];
    return (
      <RadioComponent
        key={value}
        name={name}
        tooltip={tooltip}
        inputId={`${groupName}-${name}-${value}`}
        label={presentation}
        checked={parameters[name] === value}
        value={value}
        onChange={onChange}
        groupName={groupName} />
    );
  });

  return (
    <div className="form-group">
      <Label label={label} required={required} />
      {items}
      <div className="error">
        {errorMessage}
      </div>
    </div>
  );
};

PrototypeStencilType.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  required: PropTypes.bool,
  groupName: PropTypes.string,
  parameters: PropTypes.object.isRequired,
  onChangeParameter: PropTypes.func.isRequired,
  variants: PropTypes.arrayOf(PropTypes.object).isRequired,
  errorMessage: PropTypes.string,
  tooltip: PropTypes.string,
};

PrototypeStencilType.defaultProps = {
  label: 'Prototype Stencil Type',
  name: 'prototype_stencil_type',
  groupName: 'price_modifiers',
  required: true,
  errorMessage: '',
  tooltip: Spree.helpForParameters.stencil_type,
};

export default PrototypeStencilType;
